import React, { Component } from 'react'
import Portabella from '../../Images/Mushroom/tms-portabella.webp'
import Portabella8000 from '../../Images/Mushroom/tms-portabella-8000.webp'
import Portabella8000i from '../../Images/Mushroom/tms-portabella-8000i.webp'
import Portabella4000i from '../../Images/Mushroom/tms-portabella-4000i.webp'
import Portabella2000i from '../../Images/Mushroom/tms-portabella-2000i.webp'
import StreamerPro from '../../Images/Mushroom/tms-streamer-pro.webp'
import TruffleBroadband from '../../Images/Mushroom/tms-truffle-broadband.webp'
import TruffleEx from '../../Images/Mushroom/tms-truffle-ex.webp'



class MushroomProducts extends Component {
    render() {
        return (
            <div id="m-products">
                <h3 className="w-100 text-center mb-4">
                    MUSHROOM NETWORKS ÜRÜNLER
                </h3>
                <div className='m-products-body'>
                    <div className="one" data-toggle="modal" data-target="#portabella">
                        <img src={Portabella} alt="mushroom-tmsarge-1" title="mushroom-tmsarge-1" />
                        <p >PORTABELLA</p>
                    </div>
                    <div className="one" data-toggle="modal" data-target="#portabella8000">
                        <img src={Portabella8000} alt="mushroom-tmsarge-2" title="mushroom-tmsarge-2" />
                        <p >PORTABELLA 8000 BROADBAND BONDING APPLICANCE</p>
                    </div>
                    <div className="one" data-toggle="modal" data-target="#portabella8000i">
                        <img src={Portabella8000i} alt="mushroom-tmsarge-3" title="mushroom-tmsarge-3" />
                        <p >PORTABELLA 8000i SERIES BROADBAND BONDING APPLIANCE</p>
                    </div>
                    <div className="one" data-toggle="modal" data-target="#portabella4000i">
                        <img src={Portabella4000i} alt="mushroom-tmsarge-4" title="mushroom-tmsarge-4" />
                        <p >PORTABELLA 4000i SERIES BROADBAND BONDING APPLIANCE</p>
                    </div>
                    <div className="one" data-toggle="modal" data-target="#portabella2000i">
                        <img src={Portabella2000i} alt="mushroom-tmsarge-5" title="mushroom-tmsarge-5" />
                        <p >PORTABELLA 2000i SERIES BROADBAND BONDING APPLIANCE</p>
                    </div>
                    <div className="one" data-toggle="modal" data-target="#streamerpro">
                        <img src={StreamerPro} alt="mushroom-tmsarge-6" title="mushroom-tmsarge-6" />
                        <p >STREAMER PRO</p>
                    </div>
                    <div className="one" data-toggle="modal" data-target="#trufflebroadband">
                        <img src={TruffleBroadband} alt="mushroom-tmsarge-7" title="mushroom-tmsarge-7" />
                        <p >TRUFFLE BROADBAND BONDING NETWORK APPLIANCE</p>
                    </div>
                    <div className="one" data-toggle="modal" data-target="#truffleex">
                        <img src={TruffleEx} alt="mushroom-tmsarge-8" title="mushroom-tmsarge-8" />
                        <p >TRUFFLE-EX</p>
                    </div>
                </div>

                <div className="modal fade" id="portabella" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content m-0" style={{ paddingTop: "20px" }}>
                            <div className="modal-header mx-auto modal-header-part">
                                <span className="modal-header-part-span">
                                    PORTABELLA
                                </span>

                                <button type="button" className="close x-button" data-dismiss="modal" style={{ fontSize: "24px" }}>
                                    ×
                                </button>
                            </div>
                            <div className="modal-body p-0" style={{ width: "95%", margin: "auto" }}>

                                <div style={{ textAlign: "center" }} >

                                    <div>
                                        <img src={Portabella} className="popup-img"
                                            alt="tms-portabella" title="tms-portabella" />
                                    </div>

                                </div>
                                <div>
                                    <h6>
                                        3G/4G/LTE/5G Birleştirme
                                    </h6>
                                    <p>
                                        Portabella, herhangi bir servis sağlayıcınızdan 2, 4 veya 8 hücresel SIM bağlantısını birleştiren ve akıllıca yöneten bir Broadband Bonding™ cihazıdır. Portabella, mevcut yollar üzerinde tek bir oturumu şeritleyebilir ve bu nedenle bulut geçiş hizmetimizi kullanarak tek bir süper hızlı boru oluşturabilir.
                                    </p>

                                    <h6>
                                        Canlı Video Akışı
                                    </h6>
                                    <p>
                                        Portabella, bağlı 3G, 4G, LTE, 5G modemler üzerinden sahadan herhangi bir CDN veya video sunucusuna canlı video akışı için optimize edilmiş ücretsiz bir eklenti tünelini (Streamer) destekler. Bu video için optimize edilmiş birleştirme tüneli, canlı video akışı uygulamalarının paket kaybı, gecikme, titreme ve hatta tam modem bağlantı kesilmeleri gibi ağ sorunlarından %100 korunmasını sağlar. Bu durumlarda bile canlı video akışınız sorunsuz bir şekilde devam edecektir.
                                    </p>

                                    <h6>
                                        Sağlamlaştırılmış Tasarım
                                    </h6>
                                    <p>
                                        Çeşitli Portabella modelleri, tren sertifikaları dahil olmak üzere yüksek sıcaklık ve titreşim toleranslarına sahip gömülü modemleri destekler. Diğer Portabella modelleri, ek esneklik için harici USB tabanlı modem bağlantı noktalarını destekler.
                                    </p>

                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="portabella8000" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content m-0" style={{ paddingTop: "20px" }}>
                            <div className="modal-header mx-auto modal-header-part">
                                <span className="modal-header-part-span">
                                    PORTABELLA 8000 BROADBAND BONDING APPLICANCE
                                </span>

                                <button type="button" className="close x-button" data-dismiss="modal" style={{ fontSize: "24px" }}>
                                    ×
                                </button>
                            </div>
                            <div className="modal-body p-0" style={{ width: "95%", margin: "auto" }}>

                                <div style={{ textAlign: "center" }} >

                                    <div>
                                        <img src={Portabella8000} className="popup-img"
                                            alt="tms-portabella8000" title="tms-portabella8000" />
                                    </div>

                                </div>
                                <div>
                                    Portabella 8000 Broadband Bonding Appliance, mobil veya uzak kurulumlar için uygun maliyetli ve kendi kendini iyileştiren İnternet erişimi sağlar. Sekiz adede kadar 3G/4G/LTE hücresel kablosuz hattın toplanması ve akıllı WAN düzenlemesi, İnternet performansını ve güvenilirliğini artırır. Portabella 8000, İnternet üzerinden çalışan uygulamaların ve hizmetlerin performansını ve çalışma süresini artırmak için sekiz adede kadar harici usb tabanlı 3G/4G/LTE hücresel modem donanım kilidini toplar ve akıllı bir şekilde düzenler. Artan bant genişliği sağlamak için aynı veya farklı taşıyıcılardan sekiz adede kadar 3G/4G/LTE hücresel modem toplanabilir. Portabella, araç ve demiryolu senaryoları için IP ağları üzerinden çalışan gerçek zamanlı ve gerçek zamanlı olmayan uygulamaların performansını ve güvenilirliğini artırmak için idealdir.
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="portabella8000i" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content m-0" style={{ paddingTop: "20px" }}>
                            <div className="modal-header mx-auto modal-header-part">
                                <span className="modal-header-part-span">
                                    PORTABELLA 8000i SERIES BROADBAND BONDING APPLIANCE
                                </span>

                                <button type="button" className="close x-button" data-dismiss="modal" style={{ fontSize: "24px" }}>
                                    ×
                                </button>
                            </div>
                            <div className="modal-body p-0" style={{ width: "95%", margin: "auto" }}>

                                <div style={{ textAlign: "center" }} >

                                    <div>
                                        <img src={Portabella8000i} className="popup-img"
                                            alt="tms-portabella8000i" title="tms-portabella8000i" />
                                    </div>

                                </div>
                                <div>
                                    Portabella 8000i serisi Broadband Bonding Appliance, mobil veya uzak kurulumlar için uygun maliyetli ve kendi kendini onaran İnternet erişimi sağlar. Sekiz adet 3G/4G/LTE/5G hücresel kablosuz hattın toplanması ve akıllı WAN düzenlemesi, İnternet performansını ve güvenilirliğini artırır. Portabella 8000i, İnternet üzerinden çalışan uygulamaların ve hizmetlerin performansını ve çalışma süresini artırmak için sekiz adede kadar yerleşik 3G/4G/LTE/5G hücresel modemi bir araya getirir ve akıllı bir şekilde düzenler. Aynı veya farklı taşıyıcılardan sekiz adet 3G/4G/LTE/5G hücresel modem, artırılmış bant genişliği sağlamak için bir araya getirilebilir. Portabella, araç ve demiryolu senaryoları için IP ağları üzerinden çalışan gerçek zamanlı ve gerçek zamanlı olmayan uygulamaların performansını ve güvenilirliğini artırmak için idealdir.
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="portabella4000i" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content m-0" style={{ paddingTop: "20px" }}>
                            <div className="modal-header mx-auto modal-header-part">
                                <span className="modal-header-part-span">
                                    PORTABELLA 4000i SERIES BROADBAND BONDING APPLIANCE
                                </span>

                                <button type="button" className="close x-button" data-dismiss="modal" style={{ fontSize: "24px" }}>
                                    ×
                                </button>
                            </div>
                            <div className="modal-body p-0" style={{ width: "95%", margin: "auto" }}>

                                <div style={{ textAlign: "center" }} >

                                    <div>
                                        <img src={Portabella4000i} className="popup-img"
                                            alt="tms-portabella4000i" title="tms-portabella4000i" />
                                    </div>

                                </div>
                                <div>
                                    Portabella 4000i serisi Geniş Bant Bağlama Cihazı, mobil veya uzak kurulumlar için uygun maliyetli ve kendi kendini iyileştiren İnternet erişimi sağlar. Dört 3G/4G hücresel SIM bağlantısının toplanması ve akıllı WAN düzenlemesi, İnternet performansını ve güvenilirliğini artırır. Portabella 4000i, İnternet üzerinden çalışan uygulamaların ve hizmetlerin performansını ve çalışma süresini artırmak için dört adet yerleşik 3G/4G/LTE hücresel modemi bir araya getirir ve akıllı bir şekilde düzenler. Aynı veya farklı taşıyıcılardan dört adet 3G/4G/LTE hücresel modem, artırılmış bant genişliği sağlamak için bir araya getirilebilir. Portabella, araç ve demiryolu senaryoları için IP ağları üzerinden çalışan gerçek zamanlı ve gerçek zamanlı olmayan uygulamaların performansını ve güvenilirliğini artırmak için idealdir.
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="portabella2000i" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content m-0" style={{ paddingTop: "20px" }}>
                            <div className="modal-header mx-auto modal-header-part">
                                <span className="modal-header-part-span">
                                    PORTABELLA 2000i SERIES BROADBAND BONDING APPLIANCE
                                </span>

                                <button type="button" className="close x-button" data-dismiss="modal" style={{ fontSize: "24px" }}>
                                    ×
                                </button>
                            </div>
                            <div className="modal-body p-0" style={{ width: "95%", margin: "auto" }}>

                                <div style={{ textAlign: "center" }} >

                                    <div>
                                        <img src={Portabella2000i} className="popup-img"
                                            alt="tms-portabella2000i" title="tms-portabella2000i" />
                                    </div>

                                </div>
                                <div>
                                    Portabella 2000i serisi Geniş Bant Bağlama Cihazı, mobil veya uzak kurulumlar için uygun maliyetli ve kendi kendini iyileştiren İnternet erişimi sağlar. İki 3G/4G/5G hücresel kablosuz hattın toplanması ve akıllı WAN düzenlemesi, İnternet performansını ve güvenilirliğini artırır. Portabella 2000i, İnternet üzerinden çalışan uygulamaların ve hizmetlerin performansını ve çalışma süresini artırmak için iki yerleşik 3G/4G/LTE/5G hücresel modemi bir araya getirir ve akıllı bir şekilde düzenler. Aynı veya farklı taşıyıcılardan iki 3G/4G/LTE/5G hücresel modem, artırılmış bant genişliği sağlamak için bir araya getirilebilir. Portabella, araç ve demiryolu senaryoları için IP ağları üzerinden çalışan gerçek zamanlı ve gerçek zamanlı olmayan uygulamaların performansını ve güvenilirliğini artırmak için idealdir.
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="streamerpro" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content m-0" style={{ paddingTop: "20px" }}>
                            <div className="modal-header mx-auto modal-header-part">
                                <span className="modal-header-part-span">
                                    Çözüm - Streamer PRO
                                </span>

                                <button type="button" className="close x-button" data-dismiss="modal" style={{ fontSize: "24px" }}>
                                    ×
                                </button>
                            </div>
                            <div className="modal-body p-0" style={{ width: "95%", margin: "auto" }}>

                                <div style={{ textAlign: "center" }} >

                                    <div>
                                        <img src={StreamerPro} className="popup-img"
                                            alt="tms-streamer-pro" title="tms-streamer-pro" />
                                    </div>

                                </div>
                                <div>
                                    <h6>
                                        3G/4G/LTE/5G bağlama
                                    </h6>
                                    <p className='mb-2'>
                                        Streamer PRO, canlı video akışını doğrudan kameranızdan bir video sunucusuna/CDN'ye (İçerik Dağıtım Ağı) veya doğrudan stüdyonuza yayınlayabilen bir 3G/4G/LTE/5G bağlama cihazıdır. Video, otomatik hata düzeltmeli toplu 3G/4G/LTE/5G kartları üzerinden yayınlandığından, video akışınız yüksek kaliteli videoyu destekleyebilir ve benzersiz profesyonel düzeyde güvenilirliğe sahip olacaktır.
                                    </p>
                                    <p>
                                        Web yayıncıları, kameralarından (SDI, S-video, bileşik) veya video anahtarlayıcıdan video beslemesini kolayca bağlayabilir, USB modem hücresel hava kartlarını Streamer PRO'ya ekleyebilir ve seçtikleri CDN/video sunucusuna canlı video akışı yayınlayabilir. Benzer şekilde, Streamer PRO, noktadan noktaya video dağıtımı için stüdyonuzdaki kod çözücülü bir Mushroom Networks alıcısına canlı video gönderebilir.
                                    </p>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="trufflebroadband" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content m-0" style={{ paddingTop: "20px" }}>
                            <div className="modal-header mx-auto modal-header-part">
                                <span className="modal-header-part-span">
                                    TRUFFLE BROADBAND BONDING NETWORK APPLIANCE
                                </span>

                                <button type="button" className="close x-button" data-dismiss="modal" style={{ fontSize: "24px" }}>
                                    ×
                                </button>
                            </div>
                            <div className="modal-body p-0" style={{ width: "95%", margin: "auto" }}>

                                <div style={{ textAlign: "center" }} >

                                    <div>
                                        <img src={TruffleBroadband} className="popup-img"
                                            alt="tms-truffle-broadband" title="tms-truffle-broadband" />
                                    </div>

                                </div>
                                <div>
                                    Truffle Broadband Bonding Network Appliance, artan performans ve güvenilirlik için birden fazla İnternet erişim hizmetini bir araya getirmek isteyen her büyüklükteki işletme, apartman, otel ve diğer çok kiracılı binalar için uygun maliyetli İnternet erişim çözümleri sağlar. Truffle, dört (veya isteğe bağlı olarak sekiz veya on ikiye kadar) DIA, DSL, fiber veya kablo modem hizmetinin kapasitesini ve indirilen HTTP trafiği için birleştirilmiş bağlantıların birleşik bant genişliğine eşit artan erişim bant genişliği sağlayan iki usb tabanlı hücresel veri kartını toplar. , hatta tek bir kullanıcıya. Truffle, bu yüksek erişim kapasitesini ve daha güvenilir İnternet erişimini, pahalı MPLS veya T-3 erişim hizmetinden çok daha düşük bir maliyetle sağlar. Sessiz aktif soğutma ile 1U rafa monte edilebilir form faktörüne sahiptir.
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="truffleex" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content m-0" style={{ paddingTop: "20px" }}>
                            <div className="modal-header mx-auto modal-header-part">
                                <span className="modal-header-part-span">
                                    Truffle-EX serisi Yazılım Tanımlı WAN Düzenlemesi ve Geniş Bant Birleştirme Cihazı
                                </span>

                                <button type="button" className="close x-button" data-dismiss="modal" style={{ fontSize: "24px" }}>
                                    ×
                                </button>
                            </div>
                            <div className="modal-body p-0" style={{ width: "95%", margin: "auto" }}>

                                <div style={{ textAlign: "center" }} >

                                    <div>
                                        <img src={TruffleEx} className="popup-img"
                                            alt="tms-truffle-ex" title="tms-truffle-ex" />
                                    </div>

                                </div>
                                <div>
                                    Truffle-EX serisi Yazılım Tanımlı WAN Düzenlemesi ve Geniş Bant Birleştirme Cihazı, işletmeler, kurumsal şube ofisleri ve diğer çok kiracılı binalar için uygun maliyetli ve kendi kendini iyileştiren İnternet erişimi sağlar. Birden çok İnternet erişim hattının toplanması ve akıllı WAN düzenlemesi, İnternet performansını ve güvenilirliğini artırır. Truffle-EX, İnternet üzerinden çalışan uygulamaların ve hizmetlerin performansını ve çalışma süresini artırmak için dört adede kadar (veya isteğe bağlı olarak sekiz veya on iki adede kadar) İnternet hattını toplar ve akıllı bir şekilde düzenler. Artan bant genişliği sağlamak için farklı ISP'lerden çeşitli DIA, DSL, kablo modem, MPLS, metro-ethernet veya fiber hizmetleri bir araya getirilebilir. </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}
export default MushroomProducts;